import React from 'react';
import { Line } from '@ant-design/charts';
import { Card, Col, List, Row, Space, Statistic, Typography, Switch, Flex } from 'antd';
import RangePicker from 'components/date-range-picker';
import { formatCurrency, formatNumber } from 'utils/number';
import { formatDate } from 'utils/date';

const { Text, Title } = Typography;

const Mobile = ({ viewModel }) => {
  const { summary, data, onDateRangeFilterChange, onSortByChange, rangePickerPresets, rangePickerValue, loading, filter } = viewModel;

  const salesByDay = Array.isArray(data.salesByDay)
    ? data.salesByDay.map((item) => ({
        date: formatDate(item.date),
        'Doanh số': Number(item.revenue) || 0,
      }))
    : [];

  const getStatusLabel = (status) => {
    const statusMap = {
      pending: 'Chờ xác nhận',
      confirmed: 'Đã xác nhận',
      processing: 'Đang xử lý',
      shipped: 'Đã gửi',
      delivered: 'Đã giao',
      canceled: 'Đã hủy',
    };
    return statusMap[status] || status;
  };

  return (
    <Row gutter={[12, 12]} style={{ marginInline: 0 }}>
      <Col span={24}>
        <Card size='small' loading={loading}>
          <Space direction='vertical' size={6} style={{ width: '100%' }}>
            <Title level={5} style={{ margin: 0 }}>Báo cáo bán hàng</Title>
            <Text type='secondary'>Theo dõi doanh thu và sản phẩm bán chạy của shop</Text>
            <RangePicker format='DD/MM/YY' presets={rangePickerPresets} value={rangePickerValue} onChange={onDateRangeFilterChange} />
          </Space>
        </Card>
      </Col>

      <Col span={12}><Card size='small' loading={loading}><Statistic title='Doanh thu' value={formatCurrency(summary.revenue || 0)} /></Card></Col>
      <Col span={12}><Card size='small' loading={loading}><Statistic title='Số đơn' value={summary.order_count || 0} /></Card></Col>
      <Col span={12}><Card size='small' loading={loading}><Statistic title='AOV' value={formatCurrency(summary.average_order_value || 0)} /></Card></Col>
      <Col span={12}><Card size='small' loading={loading}><Statistic title='Khách hàng' value={summary.customer_count || 0} /></Card></Col>

      <Col span={24}>
        <Card size='small' title='Xu hướng doanh số' loading={loading}>
          <Line
            data={salesByDay}
            xField='date'
            yField='Doanh số'
            height={220}
            point={{ size: 3 }}
            smooth
            yAxis={{
              label: {
                formatter: (v) => formatCurrency(v),
              },
            }}
            tooltip={{
              formatter: (datum) => {
                return {
                  name: datum.date,
                  value: formatCurrency(datum['Doanh số']),
                };
              },
            }}
          />
        </Card>
      </Col>

      <Col span={24}>
        <Card
          size='small'
          title='Top sản phẩm'
          loading={loading}
          extra={
            <Flex gap={6} align='center'>
              <Text style={{ fontSize: 12 }}>SL</Text>
              <Switch
                size='small'
                checked={filter.sortBy === 'revenue'}
                onChange={(checked) => onSortByChange(checked ? 'revenue' : 'quantity')}
              />
              <Text style={{ fontSize: 12 }}>DS</Text>
            </Flex>
          }
        >
          <List
            dataSource={data.topProducts || []}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={`${item?.product?.name || 'Sản phẩm'} ${item?.variant?.variant_title || ''}`.trim()}
                  description={`SL: ${formatNumber(item.quantity || 0)} • DS: ${formatCurrency(item.revenue || 0)}`}
                />
              </List.Item>
            )}
          />
        </Card>
      </Col>

      <Col span={24}>
        <Card size='small' title='Đơn hàng gần đây' loading={loading}>
          <List
            dataSource={data.orders || []}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <Flex justify='space-between'>
                      <span>{item.id}</span>
                      <Text type='secondary' style={{ fontSize: 12 }}>{getStatusLabel(item.status)}</Text>
                    </Flex>
                  }
                  description={`${item?.customer?.full_name || '-'} • ${formatDate(item.create_on)}`}
                />
                <Text strong>{formatCurrency(item.total_amount || 0)}</Text>
              </List.Item>
            )}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default Mobile;
